import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
import { Checkbox, LazyImage } from '@crehana/compass.ui';
import { CREHANA_BASE_URL_PRD } from '@crehana/constants';
import { PlayroomRewardIndicatorWithRive } from "../../../../PlayroomRewardIndicatorWithRive";
import { usePlayroomRewardsTranslations } from "../../../hooks";
import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
var ExchangeConfirm = function ExchangeConfirm(_ref) {
  var reward = _ref.reward,
    customCurrencyName = _ref.customCurrencyName,
    totalUserCrehanaCoins = _ref.totalUserCrehanaCoins,
    onAcceptTermsProp = _ref.onAcceptTerms;
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    acceptTerms = _useState2[0],
    setAcceptTerms = _useState2[1];
  var remainingCoinsIfRewardThisElement = totalUserCrehanaCoins - reward.coins;
  var onAcceptTerms = useCallback(function () {
    setAcceptTerms(function (prev) {
      return !prev;
    });
    onAcceptTermsProp(!acceptTerms);
  }, [acceptTerms, onAcceptTermsProp]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  var rewardRedemptionComponent = useCallback(function () {
    if (reward.can_redeemed_this_reward) {
      if (typeof reward.redemptions_allowed === 'number') {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [t('PRS_LIMIT_REMDEPTIONS_1'), "\xA0", /*#__PURE__*/_jsxs("span", {
            className: "tw-inline-block tw-text-neutral-light-800 tw-font-semibold",
            children: [reward.redemptions_available, "\xA0"]
          }), t('PRS_LIMIT_REMDEPTIONS_2')]
        });
      }
      if (typeof reward.redemptions_allowed === 'object') {
        return t('PRS_WITHOUT_LIMITS');
      }
    } else {
      return t('PRS_LIMIT_REARCH_REDEMPTIONS');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reward.can_redeemed_this_reward, reward.redemptions_allowed, reward.redemptions_available]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("section", {
      className: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-1.6 tw-mb-2.4",
      children: [/*#__PURE__*/_jsx(LazyImage, {
        src: reward.imageSrc || '',
        alt: reward.title,
        className: "tw-overflow-hidden tw-rounded-1.2 tw-w-full tw-h-14.4 sm:tw-h-20 md:tw-h-auto",
        imgClassName: "tw-object-cover tw-w-full tw-h-full"
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h3", {
          className: "tw-font-subtitle3 tw-mb-1.2",
          children: reward.title
        }), /*#__PURE__*/_jsx("p", {
          className: "tw-font-body4 tw-mb-0.8 tw-max-h-8 tw-overflow-y-auto sm:tw-max-h-full sm:tw-line-clamp-6",
          children: reward.description
        }), /*#__PURE__*/_jsx("div", {
          className: "tw-w-fit tw-mb-1.2 tw-py-0.4 tw-px-0.8 tw-bg-warning-100 tw-rounded-0.4",
          children: /*#__PURE__*/_jsx(PlayroomRewardIndicatorWithRive, {
            isStaticAnimation: true,
            coins: reward.coins,
            rewardName: customCurrencyName
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "tw-border-t tw-border-t-neutral-light-300 tw-pt-1.2",
          style: {
            borderTopStyle: 'solid'
          },
          children: [/*#__PURE__*/_jsxs("p", {
            className: "tw-mb-0.4 tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-light-100",
            children: [t('PRS_AVAILABLE_COINS'), "\xA0", /*#__PURE__*/_jsx("b", {
              className: "tw-text-neutral-light-800 dark:tw-text-neutral-light-100 tw-font-semibold",
              children: t('PRS_X_CREHANACOINS', {
                interpolation: {
                  coins: remainingCoinsIfRewardThisElement,
                  currencyName: customCurrencyName
                }
              })
            })]
          }), /*#__PURE__*/_jsx("p", {
            className: "tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-light-100",
            children: rewardRedemptionComponent()
          })]
        })]
      })]
    }), reward.can_redeemed_this_reward && /*#__PURE__*/_jsx("div", {
      className: "tw-flex tw-items-center",
      children: /*#__PURE__*/_jsx(Checkbox, {
        title: /*#__PURE__*/_jsxs(_Fragment, {
          children: [t('PRS_ACCEPT_TERMS_1'), ' ', /*#__PURE__*/_jsx("a", {
            href: "".concat(CREHANA_BASE_URL_PRD, "/legal/terminos-y-condiciones/"),
            className: "tw-font-semibold dark:tw-text-neutral-light-100",
            children: t('PRS_ACCEPT_TERMS_2')
          })]
        }),
        checked: acceptTerms,
        onChange: onAcceptTerms,
        size: "s"
      })
    })]
  });
};
export default ExchangeConfirm;